import { ReactNode } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/coaching/advisorPage/ElligibilityCountdown/ElligibilityCountdown.styl'
import moment from 'moment'
import { createPluralFormatter } from 'helpers/formatHelpers'

const getPluralDays = createPluralFormatter('day', 'days')


type ElligibilityCountdownProps = {
  value: number
  isEmphasized: boolean
  children: ReactNode
}

export const ElligibilityCountdown = (props: ElligibilityCountdownProps) => {
  const { value, isEmphasized, children } = props
  const valueLength = String(value).length
  const textClassName = cn(styles.text, {
    [styles.emphasized]: isEmphasized,
    [styles.twoDigits]: valueLength === 2,
    [styles.fewDigits]: valueLength > 2,
    [styles.manyDigits]: valueLength > 4,
  })

  const firstDateOfMonth = moment().startOf('month').format('MMM D')
  const lastDateOfMonth = moment().endOf('month').format('MMM D')
  return (
    <div className={ styles.countdown }>
      <span className={ textClassName }>
        <span className={ styles.currentValue }>
          { value }
        </span>
      </span>
      <h6 className={ styles.subtitle }>{ getPluralDays(value) }</h6>
      { children }
      <span className={ styles.minValue }>{ firstDateOfMonth }</span>
      <span className={ styles.maxValue }>{ lastDateOfMonth }</span>
    </div>
  )
}

